import React from "react";
import { Link } from "react-router-dom";
import { InstagramLogo, WhatsappLogo, EnvelopeSimple } from "@phosphor-icons/react";

export default function Footer({ content }) {
  const f = content?.footer || {};
  const s = { email: "natasha@nathabitat.com", instagram: "https://www.instagram.com/natasharaisi/", whatsapp: "https://wa.me/971507770224", ...(content?.social || {}) };
  const brand = content?.brand?.name || "NAT HABITAT";
  const email = s.email || f.email;
  const instagram = s.instagram || f.instagram;
  const whatsapp = s.whatsapp || f.whatsapp;

  return (
    <footer id="contact" data-testid="footer" className="bg-foreground text-background">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-20 md:py-28">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <img src="/logo-white.png" alt="Nat Habitat — Interior Design" className="h-40 md:h-52 w-auto" />
            <p className="mt-6 max-w-md text-background/60 leading-relaxed">{f.tagline}</p>
          </div>
          <div className="md:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.25em] text-background/40">Contact</p>
            {email && (
              <a href={`mailto:${email}`} className="mt-4 block text-lg hover-underline w-fit" data-testid="footer-email">
                {email}
              </a>
            )}
            {f.location && <p className="mt-3 text-background/60">{f.location}</p>}
          </div>
          <div className="md:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.25em] text-background/40">Follow</p>
            <div className="mt-4 flex flex-col gap-3">
              {instagram && (
                <a href={instagram} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover-underline w-fit" data-testid="footer-instagram">
                  <InstagramLogo size={18} /> Instagram
                </a>
              )}
              {whatsapp && (
                <a href={whatsapp} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover-underline w-fit" data-testid="footer-whatsapp">
                  <WhatsappLogo size={18} /> WhatsApp
                </a>
              )}
            </div>
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-background/15 flex flex-col sm:flex-row justify-between gap-4 text-[11px] uppercase tracking-[0.15em] text-background/40">
          <span>© {new Date().getFullYear()} {brand}. All rights reserved.</span>
          <Link to="/admin" className="hover:text-background/80 transition-colors" data-testid="footer-admin-link">
            Studio Login
          </Link>
        </div>
      </div>
    </footer>
  );
}
